import { render, staticRenderFns } from "./initI18n.vue?vue&type=template&id=644831ac&scoped=true&"
import script from "./initI18n.vue?vue&type=script&lang=js&"
export * from "./initI18n.vue?vue&type=script&lang=js&"
import style0 from "./initI18n.vue?vue&type=style&index=0&id=644831ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644831ac",
  null
  
)

export default component.exports